export function getCacheBuster(): string {
    const buildHash = getBuildHash();
    if (!buildHash) {
        return '';
    }
    return `?v=${buildHash}`;
}

function getBuildHash(): string | null | undefined {
    return document
        .querySelector("meta[name='sxm:buildHash']")
        ?.getAttribute('content');
}

function getVersion(): string | null | undefined {
    return document
        .querySelector("meta[name='sxm:version']")
        ?.getAttribute('content');
}
